enum EvaluationStatus {
    PENDING = "PENDING",
    INPROGRESS = "INPROGRESS",
    FINISHED = "FINISHED",
    INREVIEW = "INREVIEW",
    RETRACTED = "RETRACTED",
}

export default EvaluationStatus;
